import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {ImageProps, BackgroundImageProps} from 'app/utilities/ImageProps';

export type RepresentativeItemBlockProps = {
  name: string;
  email: string;
  description: string;
  image: ImageProps;
  iconImage: BackgroundImageProps;
  representativeEmailAddress: string;
};

const RepresentativeItemBlock = ({image, iconImage, description, name, email}: RepresentativeItemBlockProps) => {
  return (
    <div className='RepresentativeItemBlock'>
      <Image className='RepresentativeItemBlock__image' {...image} />
      <a className='RepresentativeItemBlock__mail' {...iconImage} href={`mailto:${email}`} />
      <div className='RepresentativeItemBlock__name'>{name}</div>
      <div className='RepresentativeItemBlock__description'>{description}</div>
    </div>
  );
};

export default RepresentativeItemBlock;
